const APPLICATION = "/application";
const PROFESSIONAL_CLIENT = "/professionalClient";
const PUBLIC = "/public";
const PROFESSIONAL_ACCOUNT = "/professionalAccount";
const PRINT_PDF = "/printPDF";

export const DOWNLOAD_QR_CODE_STICKER = APPLICATION + PROFESSIONAL_CLIENT + PUBLIC + PROFESSIONAL_ACCOUNT + PRINT_PDF + "/qrCode/downloadSticker";
